import styled from "styled-components";
import { themeGet } from "@styled-system/theme-get";
import { display } from "styled-system";

import { Box } from "../Grid";

const HeaderContact = styled(Box)`
  display: block;
  margin-left: auto;
  text-align: right;
  ${display}
  & > a {
    display: flex;
    justify-content: flex-end;
    padding: 0;
    font-weight: ${themeGet("fontWeights.light")};
    font-size: ${themeGet("fontSizes.5")};
    color: ${themeGet("colors.cta")};
    @media screen and (max-width: ${themeGet("breakpoints.xl")}) {
      font-size: 28px;
    }
    img {
      margin: 0 ${themeGet("space.2")};
    }
  }
  & > p {
    margin: 0;
    padding: 0;
    text-transform: uppercase;
    font-size: ${themeGet("fontSizes.0")};
  }
`;

HeaderContact.defaultProps = {
  display: ["none", null, null, "block"],
};

export { HeaderContact };
